import React from "react";
import Select from "react-select";
import { sortObjectsByAlphabet } from "../utils";

function UserDeviceGroupsField({ groups = [], selectedGroupIds = [], onChange, disabled }) {
    const fieldId = "oct-auth-user-device-groups";
    const menuPortalTarget = typeof document !== "undefined" ? document.body : null;
    const groupOptions = sortObjectsByAlphabet(groups || [], "name").map((group) => ({
        value: group.id,
        label: group.name
    }));
    const selectedOptions = groupOptions.filter((option) =>
        selectedGroupIds.map(String).includes(String(option.value))
    );

    return (
        <div className="form-group oct_auth-user-field oct_auth-user-groups-field">
            <div className="oct_auth-user-form-group">
                <label htmlFor={fieldId} className="oct_auth-user-label">Device Groups</label>
                <Select
                    inputId={fieldId}
                    instanceId={fieldId}
                    className="oct_selectsearch-v2 oct_auth-user-groups-select"
                    classNamePrefix="oct-selectsearchsub-v2"
                    value={selectedOptions}
                    onChange={(options) => onChange((options || []).map((option) => option.value))}
                    options={groupOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isClearable
                    isDisabled={disabled}
                    menuPosition="fixed"
                    menuPortalTarget={menuPortalTarget}
                    menuShouldScrollIntoView={false}
                    maxMenuHeight={220}
                    minMenuHeight={220}
                    placeholder="Choose device groups"
                    noOptionsMessage={() => "No groups found"}
                />
            </div>
        </div>
    );
}

export default UserDeviceGroupsField;
